module.exports = __webpack_public_path__ + "static/media/val.6f1f95d4.jpg";